// style imports
import './Slider.css';
import { motion } from 'framer-motion';

const ReviewCard=({item, outline})=>{
  return(
    <div className={`main_community_card main_community_review_card ${outline && 'community_outline_card'}`}>
      <section className='mues_community_profile_info mues_row_flex mues_column_gap_8'>
        <img src={item.logo} 
        alt="logo" loading='lazy' />
        <div className='mues_column_space_between
        mues_grey_I'>
          <h6 className='mues_font_weight_700'>{item.name}</h6>
          <p className='mues_font_weight_600 mues_grey_II'>{item.username}</p>
        </div>
      </section>
      <div className='mues_community_message_container mues_row_center'>
        <p className='mues_font_weight_400 mues_three_line_clamp'>{item.message}</p>
      </div>
    </div>
  )
}

const Slider = ({sliderData, outline, x, altName}) => {
  return (
    <div className='main_community_list_slider'>
      <motion.div className='mues_slider_wrapper'
      style={{x}}>
          {sliderData.map((item)=>(
          item.review ? <ReviewCard item={item} key={item.id} outline={outline}/>:<div className='main_community_card' key={item.id}>
            <img src={item.logo} alt={`${altName}-slider-img-${item.id}`}
            loading='lazy' />
          </div>
          ))}
      </motion.div>
    </div>
  )
}

export default Slider